import { Injectable } from '@angular/core';
import { DateRangeValue } from 'app/hub-components/modules/date-range-picker/types';
import { of } from 'rxjs';

@Injectable()
export class BenchmarkServiceMock {
  calculateBenchmark(dateInterval: DateRangeValue, benchmark: string) {
    return {
      startDate: new Date('2024-01-01'),
      endDate: new Date('2024-01-07'),
    };
  }
}
